import { render, staticRenderFns } from "./productForm.vue?vue&type=template&id=a156e3f8&scoped=true&"
import script from "./productForm.vue?vue&type=script&lang=js&"
export * from "./productForm.vue?vue&type=script&lang=js&"
import style0 from "./productForm.vue?vue&type=style&index=0&id=a156e3f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a156e3f8",
  null
  
)

export default component.exports